export default __webpack_public_path__ + "static/media/JaimeCasoOnzain.b688718b.png";